import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Link,
} from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  CircularProgress,
  Grid,
  Typography,
  Button,
  Paper,
  Divider,
} from '@material-ui/core';

import Alert from '../../common/components/Alert';
import MainLayout from '../../common/components/MainLayout';
import JoinEventDialog from '../components/JoinEventDialog';

import * as mainActions from '../actions';
import classes from '../../css/getCSS';
import * as routes from '../../config/routes';

class EventDetail extends Component {
  state = {
    dialog: false,
    confirmVisible: true,
  }

  componentDidMount() {
    document.title = 'Loading event...';
    window.scrollTo(0, 0);
    this.props.getEventItem(
      this.props.token,
      this.props.match.params.slug,
    );
  }

  componentWillUnmount() {
    this.props.deepUnmount();
  }

  openDialog = () => {
    this.setState({
      dialog: true,
    });
  }

  closeDialog = () => {
    this.setState({
      dialog: false,
      confirmVisible: true,
    });
  }

  inputChangedHandler = (event, field) => {
    this.props.inputChangedHandler(
      event,
      field,
      'eventForm',
      this.props.eventForm,
    );
  }

  submitHandler = (event) => {
    // this.setState({
    //   confirmVisible: false,
    // });
    this.props.submitHandler(
      event,
      'eventForm',
      this.props.eventForm,
      this.props.token,
      this.props.match.params.slug,
    );
  }

  render() {
    if (this.props.currentEvent) {
      document.title = this.props.currentEvent.title;
    }

    let loading = null;

    if (this.props.loading) {
      loading = (
        <div align="center" style={{ marginTop: '50px' }}>
          <CircularProgress align="center" size={50} /> <br />
          <Typography variant="body1">Loading. Please wait</Typography>
        </div>
      );
    }

    let errorAlert = null;
    if (this.props.error) {
      errorAlert = <Alert type="danger">{this.props.error}</Alert>;
    }

    let content = null;
    if (this.props.currentEvent) {
      const event = this.props.currentEvent;
      const text = <div dangerouslySetInnerHTML={{ __html: event.content }} />  // eslint-disable-line

      let registerBtn = null;
      if ((this.props.token && event.has_joined) || this.props.eventJoined) {
        registerBtn = (
          <Typography variant="title" style={{ color: 'green' }}>
            You have registered for the event!
          </Typography>
        );
      } else if (this.props.token && !event.has_joined) {
        registerBtn = (
          <Button variant="contained" color="primary" size="large" className={classes.button} onClick={() => this.openDialog()}>
            Register for event
          </Button>
        );
      } else {
        registerBtn = (
          <Typography variant="title" style={{ color: 'red' }}>
            Please login to register for event
          </Typography>
        );
      }

      content = (
        <Paper className={[classes.card, classes.cardFancy].join(' ')}>
          <Typography variant="headline">{event.title}</Typography>
          <span className={classes.titleUnderline} />
          <Typography variant="subheading">Venue: {event.venue}</Typography>
          <Typography variant="subheading">Timing: {event.event_on}</Typography>
          <Typography variant="subheading">
            Registrations Open: &nbsp;
            <span style={{ display: 'inline-block', marginRight: '5px' }}>Boys: {event.boys_open ? <i className="far fa-check-circle fa-sm" /> : <i className="far fa-times-circle fa-sm" />}</span>
            <span style={{ display: 'inline-block' }}>Girls: {event.girls_open ? <i className="far fa-check-circle fa-sm" /> : <i className="far fa-times-circle fa-sm" />}</span>
          </Typography>
          <br />
          {registerBtn}<br /><br />
          <Divider />
          <div style={{ fontFamily: 'Source Sans Pro' }}>{text}</div>
          <Divider />
          <br />
          {registerBtn}
          <JoinEventDialog
            open={this.state.dialog}
            close={this.closeDialog}
            confirmVisible={this.state.confirmVisible}
            actionLoading={this.props.actionLoading}
            actionError={this.props.actionError}
            submitHandler={this.submitHandler}
            inputChangedHandler={this.inputChangedHandler}
            eventForm={this.props.eventForm}
            formEnabled={event.payment_enabled}
          />
        </Paper>
      );
    }

    let rootClass = null;
    if (this.props.token) {
      rootClass = classes.dashboardLayout;
    }

    return (
      <MainLayout rootClass={rootClass} isAuthenticated={this.props.token !== null}>
        <Grid container style={{ justifyContent: 'center' }}>
          <Grid item md={6} sm={8} xs={12}>
            <br />
            <Link className={classes.linkDeCSS} to={formatRoute(routes.EVENTS)}>
              <Button variant="contained" color="default">Back to all events</Button>
            </Link>
            <br /><br />
            {loading}
            {errorAlert}
            {content}
            <br />
          </Grid>
        </Grid>
      </MainLayout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    token: state.auth.token,
    loading: state.main.loading,
    error: state.main.error,
    currentEvent: state.main.currentEvent,
    eventJoined: state.main.eventJoined,
    actionError: state.main.actionError,
    actionLoading: state.main.actionLoading,
    eventForm: state.main.eventForm,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(mainActions.onUnmount()),
    deepUnmount: () => dispatch(mainActions.deepUnmount()),
    getEventItem: (token, slug) => dispatch(mainActions.getEventItem(token, slug)),
    joinEvent: (token, id) => dispatch(mainActions.joinEvent(token, id)),
    inputChangedHandler: (event, field, form, inputs) => dispatch(
      mainActions.inputChangedHandler(event, field, form, inputs),
    ),
    submitHandler: (event, form, inputs, token, slug) => dispatch(
      mainActions.submitHandler(event, form, inputs, token, slug),
    ),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventDetail));



// WEBPACK FOOTER //
// ./src/main/containers/EventDetail.js